import type { JSX } from 'solid-js';
import { t } from '../i18n';
import { CreateProjectDialog } from './CreateProjectDialog';
import { Modal } from './Modal';

// Create a project from the console (#1727) — the human door onto
// `POST /v1/repos` and the MCP `project create` action.
//
// This shell owns exactly one thing, the dialog chrome, so the GUTS mount only
// while the dialog is on screen — the <StartPlanModal/> split. Here the split
// buys state, not a spared fetch: the draft and the verdict live in
// <CreateProjectDialog/>, so closing the dialog is what discards them.

export type CreateProjectModalProps = {
  readonly open: boolean;
  readonly token: string | null;
  readonly onCreated: () => void;
  readonly onClose: () => void;
};

export function CreateProjectModal(props: CreateProjectModalProps): JSX.Element {
  return (
    <Modal
      open={props.open}
      size="lg"
      title={t('repos.create.title')}
      desc={t('repos.create.intro')}
      onClose={props.onClose}
    >
      <CreateProjectDialog
        token={props.token}
        onCreated={props.onCreated}
        onClose={props.onClose}
      />
    </Modal>
  );
}
